export default "__VITE_ASSET__B$wqxNEF__"